import { LoadRosterStructureParams, RosterStructureRepository } from './roster-structure.repository';
import { Structure } from '../../types/structure';
import { ApiDataAccess, ApiResourceLocation } from '@softline/core';
import { SOFTLINE_API_PMS_ROSTER_STRUCTURE } from '../../roster.api';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class PmsRosterStructureRepository extends RosterStructureRepository<Structure> {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(params: LoadRosterStructureParams): Promise<Structure> {
    const location: ApiResourceLocation = {
      path: SOFTLINE_API_PMS_ROSTER_STRUCTURE,
      pathParams: { employeeId: params.employeeId },
      queryParams: {
        begindate: params.begindate,
        enddate: params.enddate,
      }
    };

    return this.#dataAccess.get(location)
  }
}
